import { Overlay } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Directive, HostListener, Injector, Input } from '@angular/core';
import { IMAGE_OVERLAY_DATA } from '@k2/common/ui/components/image-overlay/image-overlay-data';
import { ImageOverlayComponent } from '@k2/common/ui/components/image-overlay/image-overlay.component';

@Directive({
    selector: '[imageOverlay]',
    standalone: false
})
export class ImageOverlayDirective {
  @Input() imageOverlay: string;

  constructor(private overlay: Overlay, private injector: Injector) {}

  @HostListener('click')
  onClick() {
    const overlay = this.overlay.create();

    const injector = Injector.create({
      parent: this.injector,
      providers: [
        { provide: IMAGE_OVERLAY_DATA, useValue: { src: this.imageOverlay, overlay } },
      ],
    });

    const portal = new ComponentPortal(ImageOverlayComponent, null, injector);
    overlay.attach(portal);
  }
}
